import React, { useState, useEffect } from "react";
import { LoadingPopUp, ToastNotification } from "../../../../components";
import {
  CreateTransferPopUp,
  HeadersInventory,
  InventoryDashboard,
  InventoryFilter,
  InventoryManageCard,
  MultiSelectReceivingPopUp,
  StoresInventoryDisplayCard,
  Transfers,
  UploadItem,
  UploadLinkedFacilitiesPopUp,
  VerifyStockPopUp,
} from "./components";
import {
  BaseButtons,
  TextInputFieldSearch,
} from "../../../../components/atoms";
import { BlackAndWhite } from "../../../../themes/Colors";

const dummyData = ["test1", "test2", "test3"];

const Inventory = ({ subSelection, setSubSelection, auth }) => {
  const [loading, setLoading] = useState(false);
  const [toastPop, setToastPop] = useState(false);
  const [message, setMessage] = useState(false);
  const [search, setSearch] = useState("");
  const [screen, setScreen] = useState("warehouse");
  const [selectedProduct, setSelectedProd] = useState(null);

  let multiRecieveArray = [];
  const [recievingList, setRecievingList] = useState([]);
  const [multiRecieveArrayItem, setMultiRecieveArrayItem] = useState([]);

  const [uploadItemPopUp, setUploadItemPopUp] = useState(false);
  const [multiRecieve, setMultiRecieve] = useState(false);
  const [transferCreate, setTransferCreate] = useState(false);
  const [uploadLinkedFaclitiesPopUp, setUploadLinkedFaclitiesPopUp] =
    useState(false);

  const [warehouseInventoryList, setWarehouseInventoryList] = useState(null);
  const [warehouseInventoryStockList, setWarehouseInventoryStockList] =
    useState(null);

  //facilities varibales
  const [facilitiesArray, setFacilitiesArray] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [verifyStock, setVerifyStock] = useState(null);

  const [retailValue, setRetailValue] = useState(null);
  const [costValue, setCostValue] = useState(null);
  const [stockQtyCount, setStockqtyCount] = useState(null);

  // these are the varibales to allow the pop ups to open
  const [uploadStockPop, setUploadStockPop] = useState(false);

  const getProducts = async () => {
    // authentication or login function heal
    //this code is used for Ui test
    // https://budloungedatabase.onrender.com/cannaPos/reg

    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/productUpload/getProductsAdded",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const respnseData = await response.json();
      if (respnseData.product) {
        // const wait = await updateListFetch();
        setWarehouseInventoryList(respnseData.product);
      } else if (respnseData.message) {
        setWarehouseInventoryList([]);
      }
    } catch (err) {
      console.log("err", err);
    }
  };
  const getWarehouseStock = async () => {
    // authentication or login function heal
    //this code is used for Ui test
    // https://budloungedatabase.onrender.com/cannaPos/reg

    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/inventory/warehouseStock",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: auth.userId,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setWarehouseInventoryStockList(respnseData.warehouseList);
      } else if (respnseData.message) {
        setWarehouseInventoryList([]);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const ReturnStockAmount = ({ productId }) => {
    let stock = 0;
    if (warehouseInventoryStockList) {
      warehouseInventoryStockList.map((item) =>
        item.productId === productId ? (stock = item) : null
      );
    }

    return stock;
  };

  const ReturnStockDateLastCheckAmount = ({ productId }) => {
    let stockTakeDate = "loading";
    if (warehouseInventoryStockList) {
      warehouseInventoryStockList.map((item) =>
        item.productId === productId
          ? (stockTakeDate = item.stockTakeDate)
          : null
      );
    }

    return stockTakeDate;
  };

  const getStores = async () => {
    await fetch(
      "https://budloungedatabase.onrender.com/facilities/getFacilities"
    )
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setFacilitiesArray(resData);
      });
  };
  const NameAssemble = ({ product }) => {
    if (product) {
      let name =
        product.productName +
        " | " +
        product.productSubType +
        " | " +
        product.thcType +
        " | " +
        product.thcContent;
      return name;
    }
  };

  const getWareHouseInventoryValueAndProductCount = async () => {
    // authentication or login function heal
    //this code is used for Ui test
    // https://budloungedatabase.onrender.com/cannaPos/reg
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/inventory/getWarehouseInventoryValueAndProductCount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            storeId: "none",
          }),
        }
      );

      const respnseData = await response.json();
      console.log("check response", respnseData);
      if (respnseData.success) {
        setLoading(false);
        console.log("success", respnseData);
        setCostValue(respnseData.totalInventoryValue);
        setRetailValue(respnseData.retailTotalInventoryValue);
        setStockqtyCount(respnseData.inventoryItemCount);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("err", err);
    }
  };

  useEffect(() => {
    getStores();
    getProducts();
    getWarehouseStock();
  }, []);

  useEffect(() => {
    setWarehouseInventoryStockList(null);

    getWarehouseStock();
  }, [refresh]);

  useEffect(() => {
    if (toastPop) {
      setTimeout(() => {
        setToastPop(false);
      }, 5000);
    }
  }, [toastPop]);
  return (
    <div
      style={{
        height: "100%",
        width: "100%",

        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
        backgroundColor: BlackAndWhite.secondary,
      }}
    >
      {/* //header tool bar */}
      {subSelection === "myInventory" ? (
        <>
          <div
            style={{
              height: 60,
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* <div style={{ marginLeft: 20, marginRight: 20 }}>MY INVENTORY</div> */}
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "row",
                position: "relative",
                alignItems: "center",
              }}
            >
              {/* ser=arch field */}
              <div style={{ marginLeft: 10, marginRight: 10 }}>
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",

                    // width: 300,

                    borderWidth: 0.5,
                  }}
                >
                  <TextInputFieldSearch
                    placeholder={"Type here to search"}
                    height={25}
                    borderRadius={4}
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                  />
                  <div
                    style={{
                      height: 30,
                      width: 70,
                      backgroundColor: BlackAndWhite.primary,
                      borderRadius: 4,
                      display: "flex",
                      color: BlackAndWhite.secondary,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      onClick={() => setSearch("")}
                      style={{ fontSize: 12, fontWeight: "bold" }}
                    >
                      CLEAR
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginLeft: 20,
                  marginRight: 10,
                }}
              >
                <div>
                  {stockQtyCount ? Number(stockQtyCount).toFixed(2) : "loading"}
                </div>
                <div style={{ fontSize: 10, marginTop: 5 }}>PRODUCT COUNT</div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginRight: 10,
                }}
              >
                <div>
                  {costValue ? "R " + Number(costValue).toFixed(2) : "loading"}
                </div>
                <div style={{ fontSize: 10, marginTop: 5 }}>COST VALUE</div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginRight: 10,
                }}
              >
                <div>
                  {retailValue
                    ? "R " + Number(retailValue).toFixed(2)
                    : "loading"}
                </div>
                <div style={{ fontSize: 10, marginTop: 5 }}>RETAIL VALUE</div>
              </div>
              {costValue && retailValue && stockQtyCount ? null : (
                <BaseButtons
                  mini={true}
                  label={"GET WAREHOUSE VALUES"}
                  // marginTopFalse={true}
                  marginTop={-1}
                  borderRadius={8}
                  height={35}
                  minHeight={35}
                  marginRight={10}
                  size={160}
                  onClick={() => getWareHouseInventoryValueAndProductCount()}
                />
              )}
              <div style={{ flex: 1 }}></div>

              <div style={{}}>
                <InventoryFilter filterName={"FILTER"} setScreen={setScreen} />
              </div>
            </div>
            <div style={{ marginRight: 10, display: "flex" }}>
              <BaseButtons
                label={"TRANSFER"}
                mini={true}
                marginTopFalse={true}
                borderRadius={8}
                height={35}
                size={130}
                onClick={() => setTransferCreate(true)}
              />
              <div style={{ minWidth: 10 }} />
              <BaseButtons
                label={"RECIEVE"}
                mini={true}
                marginTopFalse={true}
                borderRadius={8}
                height={35}
                size={130}
                onClick={() => setUploadItemPopUp(true)}
              />
            </div>
          </div>
          {screen === "warehouse" ? <HeadersInventory /> : null}
        </>
      ) : null}

      {subSelection === "myInventory" ? (
        <div
          style={{
            width: "100%",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {screen === "warehouse" ? (
            <div
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "flex-start",
                overflowY: "auto",
                overflowX: "hidden",
                flexDirection: "column",
                scrollbarWidth: "none",
              }}
            >
              {warehouseInventoryList
                ? warehouseInventoryList.map((product, index) => {
                    return NameAssemble({ product })
                      .toLocaleLowerCase()
                      .match(search) ? (
                      <div key={index} style={{ width: "100%" }}>
                        <InventoryManageCard
                          ReturnStockAmount={ReturnStockAmount}
                          product={product}
                          productName={NameAssemble({ product })}
                          sku={product.sku}
                          supplier={product.supplier}
                          image={product.imageUrl}
                          info={ReturnStockAmount({ productId: product._id })}
                          stockTakeDate={ReturnStockDateLastCheckAmount({
                            productId: product._id,
                          })}
                          onVerifyClick={() =>
                            setVerifyStock({
                              product: {
                                stockIno: ReturnStockAmount({
                                  productId: product._id,
                                }),
                                product: product,
                              },
                            })
                          }
                        />
                      </div>
                    ) : null;
                  })
                : null}
            </div>
          ) : null}
          {screen === "stores" ? (
            <div
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "flex-start",
                overflowY: "auto",
                overflowX: "hidden",
                flexDirection: "column",
                scrollbarWidth: "none",
              }}
            >
              {facilitiesArray
                ? facilitiesArray.store.map((store, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          width: "100%",
                          marginBottom:
                            index === facilitiesArray.store.length - 1 ? 60 : 0,
                        }}
                      >
                        <StoresInventoryDisplayCard
                          search={search}
                          storeName={store.storeName}
                          store={store}
                          type={store.type}
                          auth={auth}
                          warehouseInventoryList={warehouseInventoryList}
                        />
                      </div>
                    );
                  })
                : null}
            </div>
          ) : null}
        </div>
      ) : null}
      {subSelection === "dashboard" ? (
        <InventoryDashboard setLoading={setLoading} admin={auth} />
      ) : null}
      {subSelection === "transfers" ? (
        <Transfers
          auth={auth}
          setLoading={setLoading}
          setMessage={setMessage}
          setToastPop={setToastPop}
          loading={loading}
        />
      ) : null}
      {subSelection === "countStockTake" ? (
        <div style={{ width: "100%", flex: 1, borderStyle: "solid" }}>
          Count Stock Take
        </div>
      ) : null}
      <UploadItem
        setRecievingList={setRecievingList}
        multiRecieveArray={multiRecieveArray}
        setMultiRecieve={setMultiRecieve}
        selectedProduct={selectedProduct}
        setSelectedProd={setSelectedProd}
        setLoading={setLoading}
        display={
          uploadItemPopUp && subSelection === "myInventory" ? true : false
        }
        onCloseClick={() => setUploadItemPopUp(false)}
        setUploadItemPopUp={setUploadItemPopUp}
        setUploadLinkedFaclitiesPopUp={setUploadLinkedFaclitiesPopUp}
        setMultiRecieveArrayItem={setMultiRecieveArrayItem}
        multiRecieveArrayItem={multiRecieveArrayItem}
      />
      <MultiSelectReceivingPopUp
        recievingList={recievingList}
        multiRecieveArray={multiRecieveArray}
        display={multiRecieve}
        setMultiRecieve={setMultiRecieve}
        multiRecieveArrayItem={multiRecieveArrayItem}
        setLoading={setLoading}
        setMessage={setMessage}
        setToastPop={setToastPop}
        toastPop={toastPop}
        auth={auth}
        setMultiRecieveArrayItem={setMultiRecieveArrayItem}
        setUploadItemPopUp={setUploadItemPopUp}
      />
      <UploadLinkedFacilitiesPopUp
        selectedProduct={selectedProduct}
        setSelectedProd={setSelectedProd}
        setLoading={setLoading}
        display={
          uploadLinkedFaclitiesPopUp && subSelection === "myInventory"
            ? true
            : false
        }
        onCloseClick={() => setUploadLinkedFaclitiesPopUp(false)}
        setUploadItemPopUp={setUploadLinkedFaclitiesPopUp}
      />
      <CreateTransferPopUp
        display={transferCreate}
        setTransferCreate={setTransferCreate}
        auth={auth}
        setMessage={setMessage}
        setToastPop={setToastPop}
        setLoading={setLoading}
      />
      <ToastNotification
        display={toastPop}
        message={
          message
            ? message.toLocaleUpperCase()
            : "Contact support an error has occured"
        }
      />
      {screen === "warehouse" ? (
        <VerifyStockPopUp
          display={verifyStock}
          setClose={setVerifyStock}
          selectedProduct={verifyStock}
          setMessage={setMessage}
          setLoading={setLoading}
          setToastPop={setToastPop}
          user={auth}
          refresh={refresh}
          setRefresh={setRefresh}
          info={warehouseInventoryStockList ? warehouseInventoryStockList : []}
        />
      ) : null}
      <LoadingPopUp display={loading} newWidth={"100%"} />
    </div>
  );
};

export default Inventory;
